import { ItemList } from '../orm'
import { head } from 'lodash'

class PhotographerPriceList extends ItemList {
    getEntityKey() {
        return "photographer/photographer_price"
    }

    getLoggedInPhotographerPrice() {
        return head(this.getVisibleObjects())
    }

    ensurePhotographerPriceLoaded() {
        return this.fetchListIfNeeded()
    }

    refreshPhotographPrice() {
        return (dispatch, getState) => {
            const price = this.getLoggedInPhotographerPrice()
            if ( price ) {
                dispatch(this.invalidateObject(price.id))
                dispatch(this.invalidateList())
                dispatch(this.ensurePhotographerPriceLoaded())
            }
        }
    }
    
}

export const photographerPriceList = new PhotographerPriceList("photographer_price_default")
